// TODO add next events like black friday etc
export enum FestivalSalesOffer {
  GIFT = 'GIFT',
  WR = 'WR',
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  XMAS = 'XMAS',
}
